import { render, staticRenderFns } from "./CounterItem.vue?vue&type=template&id=19d86b94&scoped=true&"
import script from "./CounterItem.vue?vue&type=script&lang=js&"
export * from "./CounterItem.vue?vue&type=script&lang=js&"
import style0 from "./CounterItem.vue?vue&type=style&index=0&id=19d86b94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d86b94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VLayout})
